import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Play, ArrowRight } from "lucide-react";
import { api } from "../lib/api";
import { track } from "../lib/analytics";
import { usePlayer } from "../context/PlayerContext";
import Seo from "../components/Seo";

export default function NotFound() {
  const [featured, setFeatured] = useState(null);
  const { playRelease } = usePlayer();
  useEffect(() => {
    track("page_not_found", { metadata: { path: window.location.pathname } });
    api.get("/releases/featured").then((r) => setFeatured(r.data)).catch(() => {});
  }, []);
  return (
    <div data-testid="not-found" className="grain flex min-h-screen flex-col items-center justify-center px-6 text-center">
      <Seo title="Page not found" noindex path={window.location.pathname} />
      <p className="text-xs font-bold uppercase tracking-[0.35em] text-gold">404</p>
      <h1 className="mt-3 font-display text-4xl font-bold uppercase tracking-tight text-white sm:text-6xl">That track isn't here</h1>
      <p className="mt-4 max-w-md text-sm text-white/60">The page moved or never existed — but the music is still playing. Start with the latest DJ Código release.</p>
      <div className="mt-8 flex flex-col items-center gap-3 sm:flex-row">
        {featured && (
          <button data-testid="notfound-play" onClick={() => playRelease(featured)} className="inline-flex items-center gap-2 rounded-full bg-gold px-7 py-4 text-sm font-bold uppercase tracking-wide text-black transition-transform active:scale-95">
            <Play size={16} fill="currentColor" /> Play {featured.title}
          </button>
        )}
        <Link to="/" data-testid="notfound-home" className="inline-flex items-center gap-2 rounded-full border border-white/20 px-6 py-3.5 text-xs font-semibold uppercase tracking-wide text-white/80 hover:border-gold/50 hover:text-gold">
          Explore all music <ArrowRight size={14} />
        </Link>
      </div>
    </div>
  );
}
